import {AssertUtils} from "goingutils";
import  dhtmlXGridObject from '../dxSource/components/dXGridObject';


export default function InitGridObj(gridId, config, vueObj, dbClick = false,treeGrid=false) {
    let {height, queryUrl = "",  data} = config;
    if (gridId != null) {
        //设置griddiv的高度
        if (AssertUtils.isNotEmpty(height)) {
            $("#" + gridId).css("height", height);
        }
        //将不需要展示的字段过滤掉
        let newFeildAry = [];
        config["fieldAry"].forEach(function (item) {
            let {type} = item;
            if (type !== "hidden") {
                newFeildAry.push(item);
            }
        });
        config["fieldAry"] = newFeildAry;
        /**
         * 如果是treeGrid控件
         */
        if (treeGrid) {
            config["fieldAry"][0]["type"] = "tree";
            config.hasPagin = false;
        }


        let myGrid = new dhtmlXGridObject(gridId);
        myGrid.method=config.methodType;
        myGrid.gridId = gridId;
        myGrid.vueObj = vueObj;
        myGrid.copy=vueObj&&vueObj.copy;
        //如果copy 不存在 默认是可以进行复制
        if(myGrid.copy==null){
            myGrid.copy=true;
        }

        myGrid.initGridCtl(config);
        myGrid._backFun=config["backFun"];
        //如果不需要头部 则销毁表格头部
        if (config.headerBar === false) {
            myGrid.detachHeader(0);
        }
        //如果存在双击 则需要屏蔽单击事件
        if (!dbClick) {
            //选择记录
            myGrid.attachEvent("onRowSelect", function (
                rowId,
                cellInd
            ) {
                if (AssertUtils.isNotNull(config["onClick"])) {
                    let rowRecord = myGrid.getRowRecord(rowId);
                    config["onClick"](rowId, cellInd, vueObj, rowRecord, myGrid);
                }
            });
        }

        //点击checkBox
        myGrid.attachEvent("onCheckbox", function (
            rowId,
            cellInd,
            state
        ) {
            //设置checkBoxEvent
            if (AssertUtils.isNotNull(config["onCheckbox"])) {
                config["onCheckbox"](rowId, cellInd, state);
            }
        });
        if (config["onCheckbox"] != null) {
            //设置checkbox事件
            myGrid.onCheckboxEvent = config["onCheckbox"];
        }

        if (!config.editor) {
            //双击记录
            myGrid.attachEvent("onRowDblClicked", function (rowId) {
                if (AssertUtils.isNotNull(config["onRowDblClicked"])) {
                    config["onRowDblClicked"](rowId, myGrid);
                }
            });
        } else {
            //初始化编辑表格
            myGrid.initEditorCtl(myGrid,config);
        }
        //如果查询url不为空则根据指定查询获取数据
        if (AssertUtils.isNotEmpty(queryUrl) && treeGrid) {

            myGrid.flushTreeGridByUrl(queryUrl);
        } else if (AssertUtils.isNotEmpty(queryUrl)) {
            myGrid.flushGridByUrl({url: queryUrl});
        }
        //如果用户定义了data传入控件 表示需要加载静态数据
        if (AssertUtils.isNotEmpty(data) && AssertUtils.isArray(data)) {
            myGrid.flushGridByJsonArray(data);
        }

        /**
         * 如果是树节点 需要重新计算排序号
         */
        if (AssertUtils.isNotEmpty(queryUrl) && treeGrid) {
            myGrid.attachEvent("onOpenEnd", function () {
                setTimeout(function () {
                    myGrid.initColOrderNumCell();
                }, 100);
                //custom code here
                return true;
            });
        }
        return myGrid;
    }
}



// WEBPACK FOOTER //
// ./goingsrc/dx/dxInitUtils/initGridObj.js